import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";

const AddUserModal = ({ show, onHide, onAdd, userType }) => {
  const [user, setUser] = useState({
    name: "",
    surname: "",
    email: "",
    ...(userType === "patients" && { pesel: "" }), // Add PESEL field for patients
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUser({ ...user, [name]: value });
  };

  const handleAddUser = () => {
    onAdd(user);
    setUser({
      name: "",
      surname: "",
      email: "",
      ...(userType === "patients" && { pesel: "" }),
    });
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Add {userType === "patients" ? "Patient" : "Employee"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="First Name"
            name="name"
            value={user.name}
            onChange={handleInputChange}
          />
        </div>
        <div className="mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="Last Name"
            name="surname"
            value={user.surname}
            onChange={handleInputChange}
          />
        </div>
        {userType === "patients" && (
          <div className="mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="PESEL"
              name="pesel"
              value={user.pesel}
              onChange={handleInputChange}
            />
          </div>
        )}
        <div className="mb-3">
          <input
            type="email"
            className="form-control"
            placeholder="Email"
            name="email"
            value={user.email}
            onChange={handleInputChange}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
        <Button variant="primary" onClick={handleAddUser}>
          Add {userType === "patients" ? "Patient" : "Employee"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddUserModal;